import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, ReactNode } from "react";

interface IProps {
  count: number;
  //* Lignes cochées qui ne sont pas sur la page affichée
  offPageCount: number;
  label: string;
  onClear: () => void;
  children?: ReactNode;
}

const TableBulkBar: FC<IProps> = ({
  count,
  offPageCount,
  label,
  onClear,
  children,
}) => (
  <div className="formalys-bulk-dock">
    <div className="formalys-bulk-bar" role="region" aria-label="Sélection">
      <p className="formalys-bulk-bar-summary" aria-live="polite">
        <span className="formalys-bulk-bar-count">{count}</span>
        <span>{label}</span>
        {offPageCount > 0 && (
          <span className="formalys-bulk-bar-note">
            {offPageCount === count
              ? "sur d'autres pages"
              : `dont ${offPageCount} sur d'autres pages`}
          </span>
        )}
      </p>
      {!!children && <div className="formalys-bulk-bar-actions">{children}</div>}
      <button
        type="button"
        className="btn formalys-bulk-bar-clear"
        onClick={onClear}
        aria-label="Désélectionner tout"
        title="Désélectionner tout (Échap)"
      >
        <FontAwesomeIcon icon={faXmark} />
        <span className="d-none d-sm-inline">Désélectionner</span>
      </button>
    </div>
  </div>
);

export default TableBulkBar;
